import React from 'react';
import { componentMap } from './ComponentMaps';

const Controls = ({ type, dateTimeType }) => {
    let Component = componentMap[type] || componentMap['default'];
    if (dateTimeType) {
        Component = componentMap[dateTimeType] || componentMap['default'];
    }
    return <Component />;
}

export default Controls;